import get from 'ts-get';

import { GetManageablePages_entry_manageablePages_edges_node_coverImages as ICoverImages } from '../interfaces/graphql';

export const getCoverImage = (coverImages: ICoverImages | undefined): string => {
  return get(coverImages, c => c.edges && c.edges[0].node && c.edges[0].node.url, '');
};
